"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _redux = require("../redux");
var _reducers = require("./reducers");
var _syncLocalStorage = require("./syncLocalStorage");
var _authReducer = _interopRequireDefault(require("../auth/authReducer"));
var _helpers = require("../auth/helpers");
var _authActions = require("../auth/authActions");
var globals = _interopRequireWildcard(require("./globals"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-underscore-dangle */
var hydrateState = function hydrateState(store, persistSharedState) {
  // Get state from localStorage
  if (persistSharedState) {
    store.dispatch((0, _syncLocalStorage.rehydrateState)());
  }
  if (globals.omni != null) {
    var session = (0, _helpers.parseServerState)(globals.omni);
    var now = Date.now();
    if (session.expiresAt != null && now < session.expiresAt) {
      store.dispatch((0, _authActions.authRequestSuccess)(session));
    }
  }
};
var getMaybeServerRenderData = function getMaybeServerRenderData() {
  if (globals.next != null && globals.next.props != null) {
    return globals.next.props.serverState;
  }
  return {};
};

// Setup the omni data stack with Apollo and Redux
// Initialize with server data if it exists and setup Redux
var initSharedState = function initSharedState(
// persistKeys?: Array<string> = [],
storeConfig) {
  if (storeConfig === void 0) {
    storeConfig = {};
  }
  if (globals.nobia != null && globals.nobia.sharedStore != null) {
    return globals.nobia.sharedStore;
  }
  var initialState = storeConfig != null && storeConfig.initialState != null ? storeConfig.initialState : getMaybeServerRenderData();
  var sharedReducers = storeConfig != null && storeConfig.persistSharedState ? _reducers.reducers : {};
  var baseReducer = (0, _redux.combineReducers)(Object.assign({
    auth: _authReducer.default
  }, sharedReducers, storeConfig.reducers));
  var combinedReducers = (0, _syncLocalStorage.rehydrateStateReducer)(baseReducer);
  var store = (0, _redux.configureStore)(Object.assign({}, storeConfig, {
    reducers: combinedReducers,
    initialState: initialState
  }));
  if (globals.nobia != null) {
    var nobia = globals.nobia; // preserve flow's type refinement

    hydrateState(store, storeConfig.persistSharedState);
    nobia.sharedStore = store;
  }
  return store;
};
var _default = exports.default = initSharedState;